"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(require("../../date-picker/locale/en_US"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _en_US["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/calendar/locale/en_US.js
// module id = 1174
// module chunks = 1